import React from 'react';
import PropTypes from 'prop-types';

import withWidth from '@material-ui/core/withWidth';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const PatientsDialogListItem = ({ onClick, Gender, width, ...otherProps }) => (
  <TableRow
    hover
    {...onClick ? {
      onClick,
      onKeyDown: (event) => {
        if (event.key === 'Enter') {
          onClick();
        }
      },
      tabIndex: 0,
    } : {}}
  >
    <TableCell>
      {`${otherProps['First Name']}, ${otherProps['Last Name']}`}
    </TableCell>
    <TableCell>
      {`${otherProps['Date of Birth']}, ${Gender}`}
    </TableCell>
    <TableCell>
      {otherProps['Contact Information']['Primary Phone']}
    </TableCell>
    {width !== 'xs' && (
      <TableCell>
        {otherProps['Address Information'].Street} {otherProps['Address Information'].Apt}
      </TableCell>
    )}
  </TableRow>
);

PatientsDialogListItem.propTypes = {
  'First Name': PropTypes.string.isRequired,
  'Last Name': PropTypes.string.isRequired,
  'Date of Birth': PropTypes.string.isRequired,
  Gender: PropTypes.string.isRequired,
  'Address Information': PropTypes.shape({
    Apt: PropTypes.string,
    Street: PropTypes.string,
  }).isRequired,
  'Contact Information': PropTypes.shape({
    'Primary Phone': PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
};

PatientsDialogListItem.defaultProps = {
  onClick: null,
};

export default withWidth()(PatientsDialogListItem);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogListItem.js